import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  Injectable,
} from '@angular/core';
import { VoiceAssistantService } from 'src/app/shared/service/voiceAssistantService.service';

@Component({
  selector: 'app-interview-user-media',
  templateUrl: './interview-user-media.component.html',
  styleUrls: ['./interview-user-media.component.scss'],
  standalone :false
})
@Injectable({
  providedIn: 'root'
})
export class InterviewUserMediaComponent implements  OnChanges, OnDestroy {
  // Inputs
  userSpeakingState: boolean = false;
  @Input() isSmallBox: boolean = false;
  @Input() isCameraOn: boolean = false;
  @Input() userName: string = 'User';

  // Outputs
  @Output() closecamera = new EventEmitter<void>();

  @ViewChild('userVideoRef', { static: false })
  userVideoRef!: ElementRef<HTMLVideoElement>;

  private userStream: MediaStream | null = null;
  
  constructor(private voiceAssistantService: VoiceAssistantService) {}

  ngOnInit() {
   this.voiceAssistantService.soundWavesState$.subscribe(
      (state) => {
        console.log('User speaking state:', state);
        this.userSpeakingState = state ;
      }
    );
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['isCameraOn']) {
      if (this.isCameraOn) {
        try {
          const preferredCameraConstraint: MediaTrackConstraints = {
            facingMode: { ideal: 'user' },
          };

          try {
            this.userStream = await navigator.mediaDevices.getUserMedia({
              video: preferredCameraConstraint,
              audio: false,
            });
          } catch (frontCameraError) {
            console.warn('Front camera unavailable, falling back to default webcam:', frontCameraError);
            this.userStream = await navigator.mediaDevices.getUserMedia({
              video: true,
              audio: false,
            });
          }

          if (this.userVideoRef?.nativeElement) {
            this.userVideoRef.nativeElement.srcObject = this.userStream;
          }
        } catch (err) {
          console.error('Failed to access webcam:', err);
          this.closecamera.emit();
        }
      } else {
        this.stopStream();
      }
    }
  }

  ngOnDestroy() {
    this.stopStream();
  }

  private stopStream() {
    if (this.userStream) {
      this.userStream.getTracks().forEach((track) => track.stop());
      this.userStream = null;
    }
  }

  get firstLetter(): string {
    return this.userName ? this.userName.charAt(0).toUpperCase() : '';
  }
}
